export class ReturnSetting {
    timePeriod: string;
    returnReason:[{ reason: string }];
    returnRegion: [{ pincode: number }];
    isLogisticsCost: boolean;
    logisticsCost: number;
    payemntMode: [{ onlinePayment: string, cod: string}];
    customDays: number; 
    creationDate: Date;
    modificationDate: Date;
  _id: any;
}